// Barra superior GOV.CO (lineamientos de MinTIC para sitios del Estado):
// logo gov.co, selector de idioma ES/EN y cambio de tema claro/oscuro.
import { AppBar, Toolbar, Box, IconButton, ButtonBase, Tooltip } from "@mui/material";
import { DarkMode, LightMode } from "@mui/icons-material";
import logoGovco from "../../../activos/imagenes/nav/gov.com.co.png";
import { useThemeContext } from "../theme/ThemeConext";
import { Idioma, useIdioma } from "../idioma/IdiomaContext";

/** Azul institucional de la barra GOV.CO. */
const AZUL_GOVCO = "#3366CC";

export default function SmallNav() {
  const { mode, toggleTheme } = useThemeContext();
  const { idioma, cambiarIdioma, t } = useIdioma();

  const opcion = (valor: Idioma, etiqueta: string) => {
    const activo = idioma === valor;
    return (
      <ButtonBase
        onClick={() => cambiarIdioma(valor)}
        aria-pressed={activo}
        aria-label={valor === "es" ? "Español" : "English"}
        sx={{
          px: 1.25,
          py: 0.4,
          borderRadius: 999,
          fontSize: "0.78rem",
          fontWeight: 700,
          letterSpacing: 0.5,
          color: activo ? AZUL_GOVCO : "#fff",
          bgcolor: activo ? "#fff" : "transparent",
          transition: "background-color .2s, color .2s",
        }}
      >
        {etiqueta}
      </ButtonBase>
    );
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{ top: 0, bgcolor: AZUL_GOVCO, zIndex: (theme) => theme.zIndex.appBar + 2 }}
    >
      <Toolbar variant="dense" sx={{ minHeight: 48, px: { xs: 2, md: 6 } }}>
        <Box
          component="a"
          href="https://www.gov.co/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ display: "flex", alignItems: "center" }}
          aria-label="Portal GOV.CO"
        >
          <Box component="img" src={logoGovco} alt="GOV.CO" sx={{ height: 30, width: "auto" }} />
        </Box>

        <Box sx={{ ml: "auto", display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            role="group"
            aria-label={t.barra.idioma}
            sx={{ display: "flex", p: 0.4, borderRadius: 999, border: "1px solid rgba(255,255,255,0.6)" }}
          >
            {opcion("es", "ES")}
            {opcion("en", "EN")}
          </Box>
          <Tooltip title={t.barra.tema}>
            <IconButton onClick={toggleTheme} sx={{ color: "#fff" }} aria-label={t.barra.tema}>
              {mode === "light" ? <DarkMode fontSize="small" /> : <LightMode fontSize="small" />}
            </IconButton>
          </Tooltip>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
